export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/whatsappIcon.5653827c.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};